import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import peerAnalysisService from '../../../../store/peerAnalysisService'

export const getSavedPortfolio = createAsyncThunk(
  'peerAnalysis/getSavedPortfolio',
  async (params, { rejectWithValue }) => {
    try {
      const res = await peerAnalysisService.getSavedPortfolio(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const getRecommendationRevenue = createAsyncThunk(
  'peerAnalysis/getRecommendationRevenue',
  async (params, { rejectWithValue }) => {
    try {
      const res = await peerAnalysisService.getRecommendationRevenue(params)

      return res.success ? res : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const getRecommendationPortfolio = createAsyncThunk(
  'peerAnalysis/getRecommendationPortfolio',
  async (params, { rejectWithValue }) => {
    try {
      const res = await peerAnalysisService.getRecommendationPortfolio(params)

      return res.success ? res : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const getRecommendationYearsOfOperation = createAsyncThunk(
  'peerAnalysis/getRecommendationYearsOfOperation',
  async (params, { rejectWithValue }) => {
    try {
      const res = await peerAnalysisService.getRecommendationYearsOfOperation(
        params,
      )

      return res.success ? res : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)
